export enum FileTypeEnum {
    Pdf = 0,
    Image = 1,
    Video = 2,
    Audio = 3,
    Document = 4,
    Spreadsheet = 5,
    Presentation = 6,
    Archive = 7,
    Other = 8,
    Html = 9
}